import { useQuery } from "@tanstack/react-query";
import { useHttp } from "./useHttp";

export function useQueryTable({
  key,
  url,
  method = "get",
  requestBody,
  enabled = true,
  staleTime = 1000 * 60 * 5,
  callback,
  pathParams,
  appendQueryParams,
}) {
  const api = useHttp({});

  return useQuery({
    queryKey: key,
    queryFn: async () => {
      if (!url) return null;

      let finalUrl = url;

      // If pathParams or queryParams need to be used, you can handle that here
      if (appendQueryParams) {
        const searchParams = new URLSearchParams(appendQueryParams).toString();
        finalUrl += `?${searchParams}`;
      }

      const res = await api[method](finalUrl, requestBody);
      if (callback) callback(res.data);
      return res.data;
    },
    onError: (e) => {
      console.error("API Error:", e);
    },
    staleTime,
    enabled,
  });
}
